// extracted by mini-css-extract-plugin
export default {"wine_btn":"ContactSierraVita_wine_btn__jMIy5"};